import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]异动雷达
 */
export function utilServer_queryAbnormalRadarUsingPOST(
  req: UtilServer.RadarDto | void,
  config?: RequestConfig
): Promise<UtilServer.ApiResultListAbnormalRadar> {
  return resource.postNoAuth('/marketQuotation/queryAbnormalRadar', req, config);
}

/**
 * [No Auth]调用中卓查询实时行情:沪深京成交额
 */
export function utilServer_queryRealTimeQuoteUsingPOST(
  req: UtilServer.StockInfoDto | void,
  config?: RequestConfig
): Promise<UtilServer.ApiResultRealTimeQuote> {
  return resource.postNoAuth('/marketQuotation/queryRealTimeQuote', req, config);
}

/**
 * [No Auth]查询当前时刻沪深京成交额与上一日差值
 */
export function utilServer_queryRealTimeQuoteDiffUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<UtilServer.ApiResultRealTimeQuoteDiff> {
  return resource.postNoAuth('/marketQuotation/queryRealTimeQuoteDiff', req, config);
}

/**
 * [No Auth]调用中卓查询行情:最新价,涨跌幅等
 */
export function utilServer_queryStockInfoUsingPOST(
  req: UtilServer.StockInfoDto | void,
  config?: RequestConfig
): Promise<UtilServer.ApiResultListStockInfo> {
  return resource.postNoAuth('/marketQuotation/queryStockInfo', req, config);
}

/**
 * [No Auth]调用中焯查询行情：带排序
 */
export function utilServer_queryStockInfoOrderlyUsingPOST(
  req: UtilServer.OrderlyStockDto | void,
  config?: RequestConfig
): Promise<Array<UtilServer.StockInfoOrderly>> {
  return resource.postNoAuth('/marketQuotation/queryStockInfoOrderly', req, config);
}
